export const FETCH_PROMOCODE_ACTIVATE = 'FETCH_PROMOCODE_ACTIVATE';
export const SUCCESS_FETCH_PROMOCODE_ACTIVATE = 'SUCCESS_FETCH_PROMOCODE_ACTIVATE';
export const FAILURE_FETCH_PROMOCODE_ACTIVATE = 'FAILURE_FETCH_PROMOCODE_ACTIVATE';


// WEBPACK FOOTER //
// ./js/actions/promoCode/index.js